// extracted by mini-css-extract-plugin
export default {"inputContainer":"CustomInput_inputContainer__GYq08","input":"CustomInput_input__05hj0"};